import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import NotificationBell from './NotificationBell';
import '../styles/Header.css';

function Header({ user, onToggleRadio, isRadioPlaying, theme, toggleTheme, onShuffle }) {
  const location = useLocation();
  const isAdmin = user.role === 'admin' || user.role === 'super_admin';
  const isMod = user.role === 'moderator';
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    window.location.href = 'https://www.gpworld.fr/logout.php';
  };

  const closeMenu = () => setMenuOpen(false);

  const NavLink = ({ to, children }) => (
    <Link to={to} className={`nav-link ${location.pathname === to ? 'active' : ''}`} onClick={closeMenu}>
      {children}
    </Link>
  );

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo" onClick={closeMenu}>
          🎵 Disney-Music
        </Link>

        {/* Liens principaux toujours visibles */}
        <nav className="header-main-nav">
          <NavLink to="/">Accueil</NavLink>
          <NavLink to="/library">Bibliothèque</NavLink>
          <NavLink to="/playlists">Playlists</NavLink>
        </nav>

        <div className="header-right">
          <button className="nav-link shuffle-btn-desktop" onClick={onShuffle} title="Lecture aléatoire">🎲</button>
          <button className={`nav-link radio-btn-desktop ${isRadioPlaying ? 'radio-active' : ''}`} onClick={onToggleRadio}>
            📻 {isRadioPlaying && <span className="radio-live-dot"></span>}
          </button>
          <NotificationBell />
          <button onClick={toggleTheme} className="theme-toggle-btn" title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}>
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
          <span className="user-name">{user.username}</span>

          <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </button>
        </div>

        {/* Menu complet (hamburger) */}
        {menuOpen && <div className="nav-overlay" onClick={closeMenu} />}
        <div className={`nav-drawer ${menuOpen ? 'open' : ''}`}>
          <div className="drawer-section">
            <div className="drawer-label">Navigation</div>
            <NavLink to="/">🏠 Accueil</NavLink>
            <NavLink to="/library">📚 Bibliothèque</NavLink>
            <NavLink to="/playlists">🎶 Playlists</NavLink>
            <NavLink to="/rankings">🏆 Classements</NavLink>
          </div>

          <div className="drawer-section">
            <div className="drawer-label">Social</div>
            <NavLink to="/party">📻 Listening Party</NavLink>
            <NavLink to="/requests">📋 Requêtes</NavLink>
            <NavLink to="/messages">💬 Messages</NavLink>
          </div>

          <div className="drawer-section">
            <div className="drawer-label">Mon compte</div>
            <NavLink to="/stats">📊 Statistiques</NavLink>
            <NavLink to="/profile">👤 Profil</NavLink>
            <NavLink to="/submit">{isAdmin ? '✅ Validation' : '📤 Proposer un album'}</NavLink>
            {(isAdmin || isMod) && <NavLink to="/admin">⚙️ Administration</NavLink>}
          </div>

          <div className="drawer-section">
            <div className="drawer-label">Actions</div>
            <button className="nav-link" onClick={() => { onShuffle(); closeMenu(); }}>🎲 Lecture surprise</button>
            <button className={`nav-link ${isRadioPlaying ? 'radio-active' : ''}`} onClick={() => { onToggleRadio(); closeMenu(); }}>
              📻 Radio {isRadioPlaying && <span className="radio-live-dot"></span>}
            </button>
          </div>

          <div className="drawer-section drawer-bottom">
            <button className="nav-link" onClick={toggleTheme}>
              {theme === 'dark' ? '☀️ Mode clair' : '🌙 Mode sombre'}
            </button>
            <button className="nav-link logout-link" onClick={handleLogout}>
              🚪 Déconnexion
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
